import React from 'react';
import { FormContext } from '../FormContext';
import InputByType from '../Inputs/InputByType';

export default function LabelAndInputRow() {
	const formContext = React.useContext(FormContext);
	const {
		rowOptions: { rowTypeData },
	} = formContext;

	const getRequiredAsterisk = () => {
		if (rowTypeData.isRequired) {
			return <span className="required-asterisk">*</span>;
		}
		return null;
	};

	return (
		<div className="info-option">
			<div className="info-option-label">
				{rowTypeData.label}
				{getRequiredAsterisk()}
			</div>
			<div className="info-option-input">
				<InputByType />
			</div>
		</div>
	);
}
